const baseStyleControl = {
  w: "100%",
  transitionProperty: "box-shadow",
  transitionDuration: "normal",
  border: "2px solid",
  borderRadius: "sm",
  borderColor: "mediumEmphasis",
  color: "white",

  _checked: {
    bg: "primary",
    borderColor: "primary",
    color: "surface",

    _disabled: {
      opacity: 0.6
    }
  },

  _focusVisible: {
    boxShadow: "outline"
  },

  _invalid: {
    borderColor: "warningBase"
  }
};

const baseStyleContainer = {
  _disabled: { cursor: "not-allowed" }
};

const baseStyleLabel = {
  userSelect: "none",
  _disabled: { opacity: 0.4 }
};

const baseStyleIcon = {
  transitionProperty: "transform",
  transitionDuration: "normal"
};

const baseStyle = {
  icon: baseStyleIcon,
  container: baseStyleContainer,
  control: baseStyleControl,
  label: baseStyleLabel
};

const sizes = {
  lg: {
    control: { w: 6, h: 6 },
    label: { fontSize: "14px" },
    icon: { fontSize: "0.75rem" }
  }
};

const defaultProps = {
  size: "lg"
};

export default {
  baseStyle,
  sizes,
  defaultProps
};
